const getTag = (tags, key) => {
  if (tags && tags.length > 0) {
    return tags.find((tag) => tag.key === key);
  }
  return null;
};

module.exports = { getTag };
